import { Component, Input, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { ScreeningViewModel } from 'libs/core/src/lib/model/view-model/screening/screening.view.model';
import { ScreenViewModel } from 'libs/core/src/lib/model/view-model/screen/screen.view.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { modalKey } from '@lib/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  template: ''
})
export class ScreeningPickerComponent implements OnInit {
  @Input() className: string = null;
  @Input() screeningId: string = null;
  @Input() screen: ScreenViewModel = null;
  @Input() screenings: ScreeningViewModel[];

  screeningsByDay: Map<string, ScreeningViewModel[]> = new Map();
  dayKeys: string[] = [];

  selectedDayScreenings: ScreeningViewModel[] = [];

  public today = DateTime.local().setZone('utc').startOf('day');

  selectedDay: number;
  selectedScreening: ScreeningViewModel;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected orderStateService: OrderStateService,
    protected modalService: BsModalService,
    protected translate: TranslateService,
    public modalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.groupScreeningsByDay();
    this.prepareDayKeys();
    this.prepareSelectedDayScreenings(this.screen.screeningTimeFrom.day);
    this.afterInit();
  }

  prepareSelectedDayScreenings(day: number) {
    this.selectedDay = day;
    this.selectedDayScreenings = this.screenings.filter((screening) => screening.screeningTimeFrom?.day === day && screening.id !== this.screeningId);
  }

  changeDay(date: DateTime) {
    this.prepareSelectedDayScreenings(date.day);
  }

  changeScreening(screening: ScreeningViewModel) {
    this.selectedScreening = screening;
  }

  confirm() {
    this.orderStateService.removeOrderWithRequest();
    this.modalService.hide(modalKey.screeningPicker);

    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() =>
        this.router.navigate([`/screen`], { relativeTo: this.route, skipLocationChange: false, queryParams: { screeningId: this.selectedScreening.id } })
      );
  }

  cancel() {
    this.modalService.hide(modalKey.screeningPicker);
  }

  afterInit() {}

  getDateButtonAriaLabel(dateFormated: string, index: number): string {
    let dayLabel: string = '';
    if (index === 0) {
      dayLabel = this.translate.instant('shared.today');
    } else if (index === 1) {
      dayLabel = this.translate.instant('shared.tomorrow');
    }

    return `${dayLabel} ${dateFormated}`;
  }

  getScreeningButtonAriaLabel(time: string, speakingType: string, printType: string, screenFeatures: string[]): string {
    return `${this.translate.instant('shared.hour')} ${time},  ${speakingType}, ${printType}, ${screenFeatures?.includes('DREAM') ? this.translate.instant('wcag.icons.dream') : ''}, ${screenFeatures?.includes('IMAX') ? this.translate.instant('wcag.icons.imax') : ''}`;
  }

  formatDay(day: string): any {
    const anyScreening = this.screeningsByDay.get(day)?.[0];
    return !anyScreening ? null : anyScreening.screeningTimeFrom;
  }

  private setCurentScreening(screeningId: string) {
    this.selectedScreening = this.selectedDayScreenings.find((screening) => screening.id === screeningId);
  }

  private groupScreeningsByDay(): void {
    if (!this.screenings || this.screenings.length === 0) return;

    const tempMap = new Map<string, ScreeningViewModel[]>();
    this.screenings.forEach((screening) => {
      const dayKey = screening.screeningTimeFrom.toISODate();
      if (!dayKey) return;

      if (tempMap.has(dayKey)) {
        tempMap.get(dayKey)?.push(screening);
      } else {
        tempMap.set(dayKey, [screening]);
      }
    });

    this.screeningsByDay = new Map([...tempMap.entries()]);
  }

  private prepareDayKeys(): void {
    this.dayKeys = Array.from(this.screeningsByDay.keys());
  }
}
